import { combineReducers } from 'redux'
import auth from './auth'
import notification from './auth/notificationSlice'
import setting from './auth/settingSlice'
import locale from './locale/localeSlice'
import admin from './admin'
import user from './user'

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        notification,
        setting,
        locale,
        admin,
        user,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
